import React, { useState, useEffect, useContext } from "react";
import "../../../assets/css/customer/dashboard/Deals.css";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import EsDealCard from "../../../components/customer/deals/EsDealCard";
import { useNavigate } from "react-router-dom";
import { checkLoggedInCustomer } from "../../../helper/CustomHelper";

const CustomerDeals = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [deals, setDeals] = useState([]);
  const [claimedMap, setClaimedMap] = useState({});

  const fetchClaimedDeals = () => {
    const escustomerId = localStorage.getItem("customerId");
    if (!escustomerId) return;

    axios
      .get(`${baseUrl}/customer/appointment/viewMyDeals`, {
        params: { escustomer_id: escustomerId },
      })
      .then((res) => {
        const map = {};
        (Array.isArray(res.data) ? res.data : []).forEach((a) => {
          // latest pehle aati hai, isliye pehli entry = latest status
          if (!map[a.esdeal_id]) map[a.esdeal_id] = a.status;
        });
        setClaimedMap(map);
      })
      .catch((err) => {
        console.log(err);
        setClaimedMap({});
      });
  };

  useEffect(() => {
    checkLoggedInCustomer(navigate);

    axios
      .get(`${baseUrl}/admin/deals/viewAllDeals`)
      .then((res) => setDeals(res.data))
      .catch((err) => console.log(err));

    fetchClaimedDeals();
  }, []);

  return (
    <div className="sgc-deals-page">
      <h1 className="sgc-deals-title">Deals &amp; Offers</h1>

      <div className="row g-3">
        {deals.map((deal) => (
          <EsDealCard
            key={deal.id}
            deal={deal}
            isPublic={false}
            claimStatus={claimedMap[deal.id]}
            onClaimed={fetchClaimedDeals}
          />
        ))}
      </div>
    </div>
  );
};

export default CustomerDeals;